<template>
    <div class="">
        <div class="index-content bgfff">
            <div class="img1 ac">
                <img src="/static/images/img01.jpg" />
                <router-link to="/accountList" class="btn-blue index-btn">
                    开始使用
                </router-link>
            </div>
            <div class="img2 ac">
                <img src="/static/images/img02.jpg" />
            </div>
            <div class="img3 ac">
                <img src="/static/images/img03.jpg" />
            </div>
            <div class="img4 ac">
                <img src="/static/images/img04.jpg" />
            </div>
            <div class="operation-tools">
                <ul>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico1"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>矩阵管理</strong>
                            <p>机构用户实现矩阵管理</p>
                            <p>账号权限分级</p>
                        </div>
                    </li>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico2"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>热文素材</strong>
                            <p>全网文章精选</p>
                            <p>满足您对媒体号运营需求</p>
                        </div>
                    </li>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico3"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>编辑排版</strong>
                            <p>文章编辑、排版更加便利</p>
                            <p>提高工作效率</p>
                        </div>
                    </li>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico4"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>一键发布</strong>
                            <p>多平台、多账号文章</p>
                            <p>一键发布</p>
                        </div>
                    </li>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico5"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>媒体号排行榜</strong>
                            <p>方便了解新媒体整体发展情况</p>
                            <p>为用户提供有效的参考导向</p>
                        </div>
                    </li>
                    <li>
                        <div class="tools-div1">
                            <span class="">
                                <i class="icons1 ico6"></i>
                            </span>
                        </div>
                        <div class="tools-div2">
                            <strong>标签管理</strong>
                            <p>媒体号定制精细标签</p>
                            <p>运营分类更方便</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer">
            <div class="foot">
                <div class="nav fl">
                    <a target="_blank" href="http://home.gsdata.cn/about-us.html">关于清博</a>
                    <a target="_blank" href="http://home.gsdata.cn/news-report/">清博资讯</a>
                    <a target="_blank" href="http://home.gsdata.cn/recruiting-talents.html">诚聘英才</a>
                    <a target="_blank" href="http://databus.gsdata.cn/">开放平台</a>
                    <a target="_blank" href="/site/usage">榜单公式</a>
                    <a target="_blank" href="http://home.gsdata.cn/cooperation.html">咨询&合作</a>
                    <a target="_blank" href="http://home.gsdata.cn/contact-us.html">联系我们</a>
                    <p>©2014-2017 北京清博大数据科技有限公司 版权所有&nbsp;&nbsp;京ICP备16036802号-1&nbsp;&nbsp;<img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/beian.png" alt="公安局备案">
                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024017" >
                                <span >京公网安备11010802024017号</span>
                            </a>
                    </p>
                </div>
                <div class="foot-imgs fr">
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbzs.jpg"/><span class="word">清博指数</span></a>
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qb.jpg"/><span class="word">清博舆论</span></a>
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbdsj.jpg"/><span class="word">清博大数据</span></a>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "left",
    props: "",
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    created() {
		
    },
    methods: {
        myNews(e){
            window.open(e,'_blank');
        },
        
    }
}
</script>
<style lang="">
    .index-content{padding-top:116px;}
    .index-content img{display:block;margin:0 auto;}
    .index-btn{width:200px;height:52px;line-height:52px;position:absolute;color:#fff;top:220px;left:0;}
    .img1{margin:0 auto 110px;max-width:1200px;position:relative;}
    .img3{margin:0 0 110px;}
    .operation-tools{text-align:center;width:1200px;margin:70px auto 0;}
    .operation-tools li{width:295px;display:inline-block;margin:0 0 70px;}
    .tools-div1{width:88px;height:88px;border:1px solid #e1e1e1;border-radius:50%;margin:0 auto;}
    .tools-div2 strong{display:block;margin:20px 0;}
    .tools-div1 span{background:#e5f5fd;display:inline-block;width:56px;height:56px;margin:15px 0 0;border-radius:50%;}
    .icons1{margin:16px 0 0;}
    .ico1{background-position:0 0;}
    .ico2{background-position:-32px 0;}
    .ico3{background-position:-64px 0;width:23px;}
    .ico4{background-position:-97px 0;}
    .ico5{background-position:-129px 0;}
    .ico6{background-position:-161px 0;width:19px;}
    .footer{width:100%;height:237px;background:#181829;}
    .footer.curr{position:fixed;bottom:0;left:0;}
    .footer .foot{width:1200px;height:100%;margin:0 auto;}
    .footer .foot .nav{font-size:14px;line-height:20px;margin:102px 0 0;}
    .footer .foot .nav a{color:#fff;display:inline-block;margin-right:15px;margin-bottom:18px;}
    .footer .foot .nav p{color:rgba(255, 255, 255, .5);font-size:12px;margin:0;}
    .footer .foot .nav p a{margin:0;color:rgba(255, 255, 255, .5);}
    .footer .foot .nav p img{width:18px;vertical-align:middle;}
    .footer .foot-imgs{margin:70px auto 0;}
    .footer .foot-imgs a{color:#7a8599;float:left;margin-right:36px;}
    .footer .foot-imgs a img{width:83px;height:83px;}
    .footer .foot-imgs a .word{display:block;text-align:center;margin-top:8px;}
</style>



// WEBPACK FOOTER //
// src/page/index.vue